import { render, staticRenderFns } from "./TicketsAgent.vue?vue&type=template&id=f341abf0&"
import script from "./TicketsAgent.vue?vue&type=script&lang=js&"
export * from "./TicketsAgent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports